export const PROGRAMS = "PROGRAMS";
export const PROGRAMS_ARE_LOADING = "PROGRAMS_ARE_LOADING";
